import React from 'react';

import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { getHelpNodePath } from '@ergeon/help-components';
import { ChevronRightIcon, DocumentTextIcon } from '@ergeon/icons/hero/mini';

import Panel from '../Panel';
import { useWikiPalette } from '../WikiPaletteProvider';

const ROW_CLASSES = classNames(
  'flex items-center gap-3 px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700',
  'focus:outline-hidden focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-blue-500',
  'dark:focus-visible:ring-blue-300',
);

const RecentlyViewed = () => {
  const { recentArticles } = useWikiPalette();

  if (!recentArticles.length) {
    return null;
  }

  return (
    <Panel meta="On this device" title="Recently viewed" titleId="wiki-recent-title">
      <ul className="flex flex-col divide-y divide-gray-200 dark:divide-gray-700">
        {recentArticles.map(({ nodeKey, section, title }) => (
          <li key={nodeKey}>
            <Link className={ROW_CLASSES} to={getHelpNodePath(nodeKey)}>
              <DocumentTextIcon aria-hidden="true" className="size-5 shrink-0 text-gray-600 dark:text-gray-400" />
              <span className="flex min-w-0 flex-1 flex-col">
                <span className="truncate paragraph-2 font-medium text-gray-900 dark:text-white">{title}</span>
                {section && (
                  <span className="truncate paragraph-3 text-gray-600 dark:text-gray-400">{section}</span>
                )}
              </span>
              <ChevronRightIcon aria-hidden="true" className="size-4 shrink-0 text-gray-600 dark:text-gray-400" />
            </Link>
          </li>
        ))}
      </ul>
    </Panel>
  );
};

export default RecentlyViewed;
